import ContentLoader from "react-content-loader";
const ProductLoader = (props) => {
    return (
        <ContentLoader
            speed={2}
            width={280}
            height={508}
            viewBox="0 0 280 508"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            {...props}
        >
            <circle cx="141" cy="161" r="111" />
            <rect x="14" y="341" rx="0" ry="0" width="269" height="101" />
            <rect x="24" y="299" rx="0" ry="0" width="247" height="25" />
            <rect x="175" y="461" rx="0" ry="0" width="103" height="33" />
            <rect x="14" y="467" rx="0" ry="0" width="94" height="28" />
        </ContentLoader>

    )
}

export default ProductLoader;